import { useEffect, useRef, useState } from "react";

/**
 * Returns true only after `isLoading` has been continuously true for `delayMs`.
 * Resets to false as soon as `isLoading` becomes false (everything finished).
 */
export const useDelayedLoading = (isLoading: boolean, delayMs = 10000) => {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (isLoading) {
      timeoutRef.current = setTimeout(() => setShow(true), delayMs);
    } else {
      setShow(false);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isLoading, delayMs]);

  return show;
};
